/**
 * HTTP 全局错误处理：统一抛出 HttpError 并触发 toast 提示
 */

const DEDUPE_MS = 2500;
const recentNotifications = new Map();
let errorNotifier = null;

export class HttpError extends Error {
  constructor(message, { url, status, errorCode, data, toastShown = false } = {}) {
    super(message);
    this.name = 'HttpError';
    this.url = url;
    this.status = status;
    this.errorCode = errorCode;
    this.data = data;
    this.toastShown = toastShown;
  }
}

export function setHttpErrorNotifier(fn) {
  errorNotifier = typeof fn === 'function' ? fn : null;
}

export function getHttpErrorNotifier() {
  return errorNotifier;
}

export function extractHttpErrorMessage(data = {}, response) {
  return data.errorDesc || data.msg || data.message || `请求失败: ${response?.status || 'unknown'}`;
}

export function createHttpError(data, response, url) {
  return new HttpError(extractHttpErrorMessage(data, response), {
    url,
    status: response?.status,
    errorCode: data.errorCode || data.code,
    data,
  });
}

export function notifyHttpError(error, { silent = false, url } = {}) {
  if (silent || !errorNotifier) return;

  const resolvedUrl = url || error?.url || '';
  const message = error?.message || '请求失败';

  if (error instanceof HttpError && error.toastShown) return;

  const dedupeKey = `${resolvedUrl}:${message}`;
  const now = Date.now();
  const lastNotifiedAt = recentNotifications.get(dedupeKey);
  if (lastNotifiedAt && now - lastNotifiedAt < DEDUPE_MS) return;

  recentNotifications.set(dedupeKey, now);
  errorNotifier(message, {
    url: resolvedUrl,
    errorCode: error?.errorCode,
    status: error?.status,
  });

  if (error instanceof HttpError) {
    error.toastShown = true;
  }
}

export function resetHttpErrorHandlerForTests() {
  errorNotifier = null;
  recentNotifications.clear();
}
